import { render, staticRenderFns } from "./ProblemHistoryList.vue?vue&type=template&id=d622fce4&scoped=true&lang=pug&"
import script from "./ProblemHistoryList.vue?vue&type=script&lang=ts&"
export * from "./ProblemHistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemHistoryList.vue?vue&type=style&index=0&id=d622fce4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d622fce4",
  null
  
)

export default component.exports